import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./MultiSelector.css";

export const MultiSelector = ({ options, selection, onChange, isReadOnly, closeOnSelection }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(new Set(selection || []));
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelected(new Set(selection || []));
  }, [selection]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggle = (modelId) => {
    const newSelected = new Set(selected);
    if (newSelected.has(modelId)) {
      newSelected.delete(modelId);
    } else {
      newSelected.add(modelId);
    }
    setSelected(newSelected);
    onChange(Array.from(newSelected));

    if (closeOnSelection) {
      setIsOpen(false);
    }
  };

  const removeItem = (modelId) => {
    const newSelected = new Set(selected);
    newSelected.delete(modelId);
    setSelected(newSelected);
    onChange(Array.from(newSelected));
  };

  const filteredOptions = options.filter((model) =>
    model.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div ref={dropdownRef} className="multi-selector">
      {/* Selected Items */}
      <div className="selected-items" onClick={() => setIsOpen(!isOpen)}>
        {selected.size > 0 ? (
          Array.from(selected).map((id) => {
            const model = options.find((m) => m.id === id);
            return (
              model && (
                <div key={id} className="selected-item">
                  {model.name}

                  {!isReadOnly && (
                    <button
                      className="remove-item"
                      onClick={() => removeItem(id)}
                    >
                      {t("multiSelector.removeItem")}
                    </button>
                  )}
                </div>
              )
            );
          })
        ) : (
          <span className="mg-l-1">
            {isReadOnly
              ? t("multiSelector.noSelection")
              : t("multiSelector.pressToSelectItems")}
          </span>
        )}
      </div>

      {/* Dropdown */}
      {!isReadOnly && isOpen && (
        <div className="dropdown">
          {/* Search Input */}
          {/* <input
            type="text"
            className="search-input"
            placeholder={t("multiSelector.searchPlaceholder")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          /> */}

          {/* Options */}
          <div className="option-list">
            {filteredOptions.length === 0 ? (
              <div className="option-item">{t("multiSelector.notFound")}</div>
            ) : (
              filteredOptions.map((model) => (
                <div
                  key={model.id}
                  className={`option-item ${
                    selected.has(model.id) ? "selected" : ""
                  }`}
                  onClick={() => toggle(model.id)}
                >
                  {model.name}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelector;
